// extracted by mini-css-extract-plugin
export default {"container":"Portfoplus_container__qyzRO","image":"Portfoplus_image__N9Tho"};